// Component Name: ShippingBanner
// Data is retrieved from Contentful
// The ShippingBanner component showcases banners that automatically rotate every 5 seconds, keeping users updated with the latest offers.
// Designed for responsiveness, the component adjusts its layout seamlessly across various device sizes.

import React, { useState, useEffect } from 'react';
import { useFormat } from 'helpers/hooks/useFormat';
import Link from '../../atoms/link';
import { Banner } from 'types/next';

interface ShippingBannerProps {
  shippingBannerContent?: Banner[];
}

const ShippingBanner = ({ shippingBannerContent }: ShippingBannerProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { formatMessage } = useFormat({ name: 'common' });

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (shippingBannerContent ? (prevIndex + 1) % shippingBannerContent.length : 0));
    }, 5000);

    return () => clearInterval(interval);
  }, [shippingBannerContent]);

  if (!shippingBannerContent || shippingBannerContent.length === 0) {
    return <div>{formatMessage({ id: 'shippingBanner', defaultMessage: 'No banner content available' })}</div>;
  }

  const currentBanner = shippingBannerContent[currentIndex];

  return (
    <div className="flex min-h-[70px]  w-full items-center justify-center p-[12.8px]">
      <Link link={`/${currentBanner?.link}`} className="flex items-center justify-center">
        <div className="flex items-center justify-center text-center text-[16px] font-bold leading-[19.2px] transition-all duration-1000 ease-in-out sm:text-[19.2px]">
          {currentBanner?.bannertext}
        </div>
        <img
          src={`https://${currentBanner?.image?.defaultHost}/i/${currentBanner?.image?.endpoint}/${currentBanner?.image?.name}`}
          alt={currentBanner?.name}
          className="ml-6 h-[35px] w-[35px] transition-all duration-1000 ease-in-out"
        />
      </Link>
    </div>
  );
};

export default ShippingBanner;
